import "./ClinkRicontattoPage.css";
import { t } from "../../services/formatters";
import { Button } from "../../components/Button";
import { Breadcrumb } from "../../components/Breadcrumb";
import { FormDatiUtente } from "../../components/FormDatiUtente";
import { Informative } from "../../components/Informative";
import { useClinkRicontattoPage } from "./useClinkRicontattoPage";
import { ErrorModal } from "../../components/ErrorModal";
import { useEffect } from "react";

export const ClinkRicontattoPage = () => {
  const { next, read, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError } = useClinkRicontattoPage();

  useEffect(() => {
    window.dataLayer.push({
      event: "customPageview",
      virtualPageURL: "/fa3/fissa-appuntamento/clink-form",
      crmIdentification: read("utenteRiconosciuto") && read("utenteRiconosciuto") == true ? "utente riconosciuto" : "nuovo utente",
      privacy_mtk_consent: "",
      funnelVersion: "nuovo",
      capFiliale: read("cap"),
      presa_info: read("solo_info"),
    });
  }, []);

  return (
    <div id="dati-personali-non-riconosciuto-page">
      <Breadcrumb />

      <FormDatiUtente title="Inserisci i tuoi dati per essere contattato" />

      <Informative />

      <div className="section text-center">
        <Button id="go-to-select-state-btn" onClick={next} classList="btn-responsive always-style" loading={isCreaAppuntamentoBusy()} text={t("avanti")} />
      </div>

      <ErrorModal
        open={fetchError}
        text={fetchErrorMessage}
        onCloseModal={() => {
          setFetchError(false);
        }}></ErrorModal>
    </div>
  );
};
